import {notFound} from "@tanstack/react-router";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {hasWorkspaceUiConfig} from "~/workspaceConfig/configRuntime";

export function notFoundIfWorkspaceConfigPresent(workspaceId: Uuid): void {
    if (hasWorkspaceUiConfig(workspaceId) === true) {
        throw notFound();
    }
}
